import React, { useEffect, useState } from 'react'
import { Button, notification } from 'antd'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'

import { addRedirect, fetchAllRedirects, resetRedirectsActionStatus } from '~actions'
import { ResultModal, RedirectCard } from '~components'
import { getCurrentUser } from '~context'
import { PageLayout, Spinner } from '~stories'

import styles from './AddRedirect.module.css'

const PAGE_TITLE = 'New Redirect'
const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const NewRedirect = ({
  addRedirect,
  allRedirects,
  fetchAllRedirects,
  newRedirectId,
  updateMessage,
  updateStatus
}) => {
  const { access_token: accessToken, userDetails: { isContentEditor } } = getCurrentUser()
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const [redirect, setRedirect] = useState({
    destination: '',
    id: uuidv4(),
    permanent: false,
    source: '',
    type: 'add'
  })

  useEffect(() => {
    fetchAllRedirects().finally(() => setIsDataLoaded(true))
  }, [fetchAllRedirects])

  const handleSubmit = ({ id, source, destination, permanent }) => {
    if (!isContentEditor) {
      notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
      return
    }

    // Prevent duplicate redirects
    const duplicate = allRedirects.find(
      r => r.source === source && r.destination === destination
    )
    if (duplicate) {
      notification.error({ message: 'A redirect with this source and destination already exists.' })
      return
    }

    // Prevent same source and destination
    if (source === destination) {
      notification.error({ message: 'Source and destination cannot be the same.' })
      return
    }

    addRedirect({
      id,
      source,
      destination,
      permanent
    }, accessToken)
  }

  const handleModalClose = () => {
    resetRedirectsActionStatus()
  }

  const addRedirectsButton = (
    <Button
      onClick={() => {
        resetRedirectsActionStatus()
        window.location.reload()
      }}
      type="primary"
    >
      Add Another
    </Button>
  )

  const goToListRedirectButton = (
    <Route key="listRedirects" render={({ history }) => (
      <Button
        onClick={() => {
          resetRedirectsActionStatus()
          history.push('/redirects')
          window.location.reload()
        }}
        type="primary"
      >
        Go to Redirects List
      </Button>
    )} />
  )

  const editRedirect = (
    <Route key="editRedirect" render={({ history }) => (

      <Button
        onClick={() => {
          newRedirectId && history.push(`/redirects/${newRedirectId}/edit`)
          window.location.reload()
        }}
        type="primary"
      >
        Keep Editing
      </Button>
    )} />
  )

  if (!isDataLoaded) return <Spinner isLoading />

  return (
    <PageLayout title={PAGE_TITLE}>
      <div className={styles.AlertsLayoutBackground}>
        <RedirectCard
          onSubmit={handleSubmit}
          redirect={redirect}
          setRedirect={setRedirect}
          type="add"
        />
      </div>
      {
        updateStatus &&
        <ResultModal
          actions={[
            editRedirect,
            goToListRedirectButton,
            addRedirectsButton
          ]}
          handleCancel={handleModalClose}
          status="success"
          title={updateMessage}
        />
      }
    </PageLayout>
  )
}

const mapStateToProps = ({ redirects }) => ({
  allVenues: redirects.allVenues || [],
  allRedirects: redirects.allRedirects || [],
  newRedirectId: redirects.newRedirectId,
  updateMessage: redirects.message,
  updateStatus: redirects.success
})

const mapDispatchToProps = {
  addRedirect,
  fetchAllRedirects
}

NewRedirect.propTypes = {
  addRedirect: PropTypes.func,
  allRedirects: PropTypes.array,
  allVenues: PropTypes.array,
  fetchAllRedirects: PropTypes.func,
  newRedirectId: PropTypes.string,
  updateMessage: PropTypes.string,
  updateStatus: PropTypes.bool
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewRedirect)
